
export default function Reviews() {
  const reviews = [
    {
      name: '田中 健太',
      age: '30代男性',
      rating: 5,
      title: 'ポイント管理から解放された！',
      content: '以前は複数のカードのポイントを管理するのが面倒で、気づいたら失効していることも多かったです。Gold Timeにしてからはポイントが自動で値引きされるので、何も考えなくてOK。サブスクの支払いも毎月少しずつ安くなっていて嬉しいです。',
      date: '2024年12月',
    },
    {
      name: '佐藤 美咲',
      age: '40代女性',
      rating: 5,
      title: '空港ラウンジが無料で使えるのが最高',
      content: '年に数回海外旅行に行くので、空港ラウンジが無料で使えるのは本当にありがたいです。年会費も年5回使えば無料なので、実質タダでゴールドカードの特典が受けられています。旅行保険も3,000万円付いているので安心です。',
      date: '2024年11月',
    },
    {
      name: '山本 大輔',
      age: '20代男性',
      rating: 4,
      title: '外食好きにはおすすめ',
      content: '外食が多いので、外食利用でポイント4倍になるのは嬉しいポイント。J\'sコンシェルのクーポンも使えば、さらにお得に食事ができます。ただ、ポイントの使い道が値引きだけなのは少し物足りないかも。マイルに交換したい人には向かないかな。',
      date: '2024年10月',
    },
    {
      name: '鈴木 恵子',
      age: '50代女性',
      rating: 5,
      title: 'カードデザインが素敵',
      content: '黒とゴールドのデザインがとても高級感があって気に入っています。裏面にもデザインがあるのは珍しいですね。機能面でも、ポイントが自動で値引きされるのでポイント管理が苦手な私にはぴったりでした。',
      date: '2024年9月',
    },
  ];

  const averageRating = (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <section className="py-16 bg-[#F8F9FA]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-3 text-center">
          ジャックス Gold Timeの口コミ・評判
        </h2>
        <div className="flex items-center justify-center gap-2 mb-12">
          <div className="flex items-center">
            {[1, 2, 3, 4, 5].map((star) => (
              <i
                key={star}
                className={`ri-star-fill text-xl ${star <= Math.round(Number(averageRating)) ? 'text-[#C9A227]' : 'text-gray-300'}`}
              ></i>
            ))}
          </div>
          <span className="text-2xl font-bold text-[#1A1A2E]">{averageRating}</span>
          <span className="text-gray-500">/ 5.0</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-[#1A1A2E] to-[#16213E] rounded-full">
                    <i className="ri-user-line text-[#E8D48B]"></i>
                  </div>
                  <div>
                    <p className="font-bold text-[#1A1A2E] text-sm">{review.name}</p>
                    <p className="text-gray-500 text-xs">{review.age}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className={`ri-star-fill text-sm ${star <= review.rating ? 'text-[#C9A227]' : 'text-gray-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <h4 className="font-bold text-[#1A1A2E] mb-2">{review.title}</h4>
              <p className="text-gray-600 text-sm leading-relaxed mb-3">{review.content}</p>
              <p className="text-gray-400 text-xs">{review.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
